import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = ({
  isLoading: false
})

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  }
})

export const {
  toggleGlobalLoading
} = appSlice.actions

export default appSlice.reducer
